import { Component } from '@angular/core';
import { ShimmerLoadingComponent } from '../shimmer-loading/shimmer-loading.component';
import { Store } from '@ngrx/store';
import { ConfigService } from '../core';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

@Component({
	selector: "app-shimmer-loading-patientweb",
	standalone: true,
	imports: [ShimmerLoadingComponent, CommonModule],
	templateUrl: "./shimmer-loading-patientweb.component.html",
	styleUrl: "./shimmer-loading-patientweb.component.scss",
})
export class ShimmerLoadingPatientwebComponent {
	isUkDfp$ = this.config.config$.pipe(
		map((config) => config.WhiteLabelName === "uk-dfp")
	);
  
	logo$ = this.isUkDfp$.pipe(
		map((isUkDfp) =>
			isUkDfp ? "/assets/img/ukdfplogo.png" : "/assets/img/synlab-logo.svg"
		)
	);

	constructor(private config: ConfigService) {}
}
